<div
    class="grid grid-cols-1 gap-x-16 gap-y-8 py-16"
    [ngClass]="{
        'lg:grid-cols-2': vehicle().equipment.length >= 16,
        'lg:grid-cols-1': vehicle().equipment.length < 16,
    }"
>
    @for (item of vehicle().equipment; track $index) {
        <lib-key-value [key]="item.key" [value]="item.value" />
    }
</div>
